module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalAttributes = [];\nvar rowActionsProperties = config.rowActionsProperties || {};\nif(config.isHead && rowActionsProperties.colWidth){\nadditionalAttributes.push('width=\"' + rowActionsProperties.colWidth + '\"');\n}\nvar colSpan = 1;\nvar rowSpan = 1;\nif(rowActionsProperties.colSpan) colSpan = rowActionsProperties.colSpan;\nif(rowActionsProperties.rowSpan) rowSpan = rowActionsProperties.rowSpan;\nlet usedActions = config.rowActions\nif(config.isHead) usedActions = config.headRowActions\n%>\n<td colspan=\"<%= colSpan %>\" rowspan=\"<%= rowSpan %>\" <%- additionalAttributes.join(' '); %>>\n<%\nif(config.isHead) {\n%>\n<div class=\"buttons\">\n<%\nif((usedActions.customs || []).length > 0){\nfor(var b in usedActions.customs){\nvar button = usedActions.customs[b] || {};\nif(button.symbolOnly === undefined) button.symbolOnly = true;\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: button.buttonType, context: button.buttonContext || config.buttonContext, mode: button.mode, symbolOnly: button.symbolOnly } }); %><%\n}\n}\nif(usedActions.showSelectColumns){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showSelectColumns', context: config.buttonContext, symbolOnly: true, inline: true } }); %><%\n}\n%>\n</div>\n<%\n} else {\nif(config.customColActionsFile){\n%><%- include('../../../' + config.customColActionsFile, { formMapping: formMapping, model: model, config: config, resourceData: resourceData }) %><%\n} else {\n%>\n<div class=\"buttons\">\n<%\nif((usedActions.customs || []).length > 0){\nfor(var b in usedActions.customs){\nvar button = usedActions.customs[b] || {};\nif(button.symbolOnly === undefined) button.symbolOnly = true;\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: button.buttonType, context: button.buttonContext || config.buttonContext, mode: button.mode, symbolOnly: button.symbolOnly } }); %><%\n}\n}\nif(usedActions.edit){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: config.buttonContext, symbolOnly: true } }); %><%\n}\nif(usedActions.delete){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: config.buttonContext, symbolOnly: true } }); %><%\n}\n%>\n</div>\n<%\n}\n}\n%>\n</td>"
  , __filename = "node_modules/frontend-controller/baseComponents/tableSimple/colActions.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalAttributes = [];
var rowActionsProperties = config.rowActionsProperties || {};
if(config.isHead && rowActionsProperties.colWidth){
additionalAttributes.push('width="' + rowActionsProperties.colWidth + '"');
}
var colSpan = 1;
var rowSpan = 1;
if(rowActionsProperties.colSpan) colSpan = rowActionsProperties.colSpan;
if(rowActionsProperties.rowSpan) rowSpan = rowActionsProperties.rowSpan;
let usedActions = config.rowActions
if(config.isHead) usedActions = config.headRowActions

    ; __line = 13
    ; __append("\n<td colspan=\"")
    ; __line = 14
    ; __append(escapeFn( colSpan ))
    ; __append("\" rowspan=\"")
    ; __append(escapeFn( rowSpan ))
    ; __append("\" ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">\n")
    ; __line = 15
    ; 
if(config.isHead) {

    ; __line = 17
    ; __append("\n<div class=\"buttons\">\n")
    ; __line = 19
    ; 
if((usedActions.customs || []).length > 0){
for(var b in usedActions.customs){
var button = usedActions.customs[b] || {};
if(button.symbolOnly === undefined) button.symbolOnly = true;

    ; __line = 24
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: button.buttonType, context: button.buttonContext || config.buttonContext, mode: button.mode, symbolOnly: button.symbolOnly } }) )
    ; 
}
}
if(usedActions.showSelectColumns){

    ; __line = 28
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showSelectColumns', context: config.buttonContext, symbolOnly: true, inline: true } }) )
    ; 
}

    ; __line = 30
    ; __append("\n</div>\n")
    ; __line = 32
    ; 
} else {
if(config.customColActionsFile){

    ; __line = 35
    ; __append( include('../../../' + config.customColActionsFile, { formMapping: formMapping, model: model, config: config, resourceData: resourceData }) )
    ; 
} else {

    ; __line = 37
    ; __append("\n<div class=\"buttons\">\n")
    ; __line = 39
    ; 
if((usedActions.customs || []).length > 0){
for(var b in usedActions.customs){
var button = usedActions.customs[b] || {};
if(button.symbolOnly === undefined) button.symbolOnly = true;

    ; __line = 44
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: button.buttonType, context: button.buttonContext || config.buttonContext, mode: button.mode, symbolOnly: button.symbolOnly } }) )
    ; 
}
}
if(usedActions.edit){

    ; __line = 48
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: config.buttonContext, symbolOnly: true } }) )
    ; 
}
if(usedActions.delete){

    ; __line = 51
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: config.buttonContext, symbolOnly: true } }) )
    ; 
}

    ; __line = 53
    ; __append("\n</div>\n")
    ; __line = 55
    ; 
}
}

    ; __line = 58
    ; __append("\n</td>")
    ; __line = 59
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/tableSimple/colActions.ejs

}